import { render, staticRenderFns } from "./RealTeamEmblem.vue?vue&type=template&id=9c384020&"
import script from "./RealTeamEmblem.vue?vue&type=script&lang=js&"
export * from "./RealTeamEmblem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports